<template>
  <div class="senWord-detail">
    <!-- 敏感词 员工聊天记录 -->
    <el-dialog
      :visible.sync="dialogShow"
      :modal-append-to-body="false"
      width="704px"
      style="margin-top:5vh;"
      class="senWord-dialog"
      :close-on-click-modal="false"
    >
      <div slot="title" class="title">{{ wordName }}</div>
      <div class="wrap">
        <div class="wrap-top">
          <div class="classification">
            <span>归属：{{ classifiName&&classifiName!=null?classifiName:'-' }}</span>
          </div>
          <div class="btn-wrap">
            <el-date-picker
              v-model="searchSelectTime"
              size="mini"
              type="daterange"
              :editable="false"
              value-format="yyyy-MM-dd"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              @change="selectTime"
              :picker-options="pickerOptions"
              :clearable="false"
              style="width: 240px; margin-right: 10px"
            >
            </el-date-picker>
            <el-button
              v-if="mgctjdcygmx"
              type="primary"
              size="mini"
              @click="handleExport"
              >导出</el-button
            >
          </div>
        </div>
        <div class="wrap-body">
          <el-table 
            size="small"
            :data="tableData"
            v-loading="flag"
            fit
            highlight-current-row
            :header-cell-style="{ background: '#F9F9F9' }"
            height="400"
            empty-text="暂无敏感词的违规情况"
            ref="cusChatTable"
            style="font-size: 13px"
          >
            <el-table-column
              align="center"
              prop="users"
              label="员工"
              min-width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="department"
              label="所属部门"
              min-width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="hitCount"
              label="出现次数"
              min-width="150"
            ></el-table-column>
          </el-table>
          <Pagination
            :childMsg="pageparm"
            :pageSizes="pageSizes"
            @callBack="callBack"
          ></Pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRecordUsersList } from "@/api/senWord/senWord.js"
export default {
  name: 'SenDetail',
  data() {
    return {
      mgctjdcygmx: false, // 导出明细权限
      wordName: '',     // 所选敏感词
      classifiName: '', // 分类名称
      flag: false,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      dialogShow: false,
      tableData: [],
      searchSelectTime: [],
      params: {
        wordId: '',       // 敏感词id（必传）
        startTime: '',
        endTime: '',      // 查询时间（必传）
        current: 1,
        size: 20          // 分页参数
      },
      // 日期只能选择一个月范围内
      choiceDate: '',
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate = minDate.getTime()
          if (maxDate) {
            this.choiceDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.choiceDate && this.choiceDate != null) {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.choiceDate - one
            const maxTime = this.choiceDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      }
    }
  },
  watch: {
    btnAuthority: {
      handler(newVal,oldVal) {
        if(newVal.length > 0) {
          newVal.forEach(item => {
            if(item.pname == '敏感词统计') {
              let senBtnAuthority = item.cfunBu
              if(senBtnAuthority.indexOf('mgctjdcygmx') != -1) {
                // 可绑定、解绑
                this.mgctjdcygmx = true
              }else {
                this.mgctjdcygmx = false
              }
            }
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority
    }
  },
  methods: {
    show(data,time) {
      this.tableData = []
      this.classifiName = data.wordTypeName
      this.wordName = data.wordName
      this.dialogShow = true
      this.params.wordId = data.wordId
      this.params.startTime = time[0]
      this.params.endTime = time[1]
      this.searchSelectTime = time
      this.getData()
    },
    // 分页回调函数
    callBack(parm) {
      this.params.current = parm.currentPage;
      this.params.size = parm.pageSize;
      this.getData();
    },
    // 导出
    handleExport() {
      let hour =" 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      let hour2 =" 23:59:59"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      let obj = JSON.parse(JSON.stringify(this.params))
      obj.startTime = obj.startTime + hour
      obj.endTime = obj.endTime + hour2
      this.download('/sensitive/record/user/export', `敏感词员工统计表_${new Date().getTime()}.xlsx`,{
        ...obj
      },localStorage.getItem("Authorization"))
    },
    // 时间处理
    selectTime(dataTime) {
      console.log('dataTime',dataTime)
      if(dataTime != null) {
        this.params.startTime = dataTime[0];
        this.params.endTime = dataTime[1];
      }else {
        this.params.startTime = ''
        this.params.endTime = ''
      }
      this.params.current = 1;
      this.getData();
    },
    // 获取数据
    getData() {
      this.flag = true
      let hour =" 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      let hour2 =" 23:59:59"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      let obj = JSON.parse(JSON.stringify(this.params))
      obj.startTime = obj.startTime + hour
      obj.endTime = obj.endTime + hour2
      getRecordUsersList(obj,localStorage.getItem("Authorization"),true).then(res => {
        if(res.error.code == 200){
          this.pageparm.total = res.data.total;
          this.tableData = res.data.result;
          this.flag = false
        }
      }).catch(err => {
        this.flag = false
        console.log(err,'errr')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .senWord-dialog {
  .el-dialog__header {
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-dialog__footer {
    padding: 0;
  }
}
.senWord-detail {
  .title {
    font-size: 16px;
    font-weight: bold;
  }
  .wrap {
    .wrap-top {
      margin-bottom: 15px;
      .classification {
        margin-bottom: 10px;
      }
      .btn-wrap {
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
</style>